import { AppEUGroup } from '../Apps';
import AppManagementModel from './AppManagementModel';
import AppManagementRequest from './AppManagementRequest';

export default class AppEUGroupRequest extends AppManagementRequest {
    /**
     * 
     * @param {AppManagementModel} app 
     * @param {import('context/User/UserContext').ContextUser} createdBy 
     * @param {object} AppEUGroupXREF 
     */
    constructor(app, createdBy, AppEUGroupXREF) {
        super(app, createdBy);
        /**
         * @type {AppEUGroup}
         */
        this.AppEUGroupXREF = AppEUGroupXREF
			? new AppEUGroup(AppEUGroupXREF)
			: new AppEUGroup();
    }
}
